var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid h-100 d-flex flex-column"},[(_vm.isLoading)?_c('LoadingBalloonAnimation'):[_c('TeamSubscription',{attrs:{"teamId":_vm.activeTeamId,"type":_vm.billingMethod}}),_c('TeamMembersList')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }